module.exports = __webpack_public_path__ + "img/others_14.52af768f.jpg";